import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoginRequest } from 'src/app/core/models/login-request.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(public _httpClient: HttpClient) { }

  baseUrl: string = environment.baseUrl + '/login';

  post(loginRequest: LoginRequest, params?: any) {
    return this._httpClient.post<LoginRequest>(this.baseUrl, loginRequest, { params: params });
  }
}
